import React from 'react';
import { Box, Flex, Text, Avatar, VStack, Select } from '@chakra-ui/react';
import { Home } from 'lucide-react';
import { useCommitteeContext } from '../context/CommitteeContext';
import { useNavigate } from 'react-router-dom';
const TEAL = '#00897B';
const SIDEBAR_BG = '#C8E6C0';
const CELL_BG = '#F1FAF1';
const CELL_ACTIVE_BG = '#B2DFDB';
type CommitteeMember = {
  position: string;
  name: string;
};
const committeeData: Record<string, CommitteeMember[]> = {
  international_marketing: [{
    position: 'WPGA - WA',
    name: 'KYLE HINRICHS'
  }, {
    position: 'WPGA - WA Alt.',
    name: 'AARON FLANSBURG'
  }],
  domestic_marketing: [{
    position: 'WPGA - WA',
    name: 'KEVIN MADER'
  }, {
    position: 'WPGA - WA Alt.',
    name: 'KYLE HINRICHS'
  }],
  research: [{
    position: 'WPGA - WA',
    name: 'KYLE SCHULTHEIS'
  }, {
    position: 'WPGA - WA Alt.',
    name: 'KYLE HINRICHS'
  }],
  information_government_education: [{
    position: 'WPGA - WA',
    name: 'GREG FERREL'
  }, {
    position: 'WPGA - WA Alt.',
    name: '(Vacant)'
  }]
};
export const committeeMembers: CommitteeMember[] = [];
export function CommitteeSidebar() {
  const {
    selectedIndex,
    setSelectedIndex,
    selectedCommittee
  } = useCommitteeContext();
  const navigate = useNavigate();
  const members = committeeData[selectedCommittee] ?? [];
  return <Box as="nav" bg={SIDEBAR_BG} w="290px" minW="290px" position="fixed" top="64px" left={0} bottom={0} zIndex={90} display="flex" flexDirection="column" overflowY="hidden" data-id="element-65">
      {/* User Box */}
      <Flex align="center" gap={3} px={4} py={4} borderBottom="1px solid rgba(0,137,123,0.25)" flexShrink={0} data-id="element-66">
        <Avatar name="Keith Price" bg="#7B1FA2" color="white" size="md" fontWeight="bold" getInitials={() => 'KP'} data-id="element-67" />
        <Box data-id="element-68">
          <Text fontWeight="bold" color={TEAL} fontSize="md" lineHeight="1.2" data-id="element-69">
            Keith Price
          </Text>
          <Text color={TEAL} fontSize="sm" opacity={0.85} data-id="element-70">
            zMagic Solutions
          </Text>
        </Box>
      </Flex>

      {/* Home nav item */}
      <Box flexShrink={0} pt={2} mb={2} data-id="element-71">
        <Flex align="center" gap={4} px={5} py={3} cursor="pointer" borderRadius="md" _hover={{
        bg: 'rgba(0,137,123,0.12)'
      }} onClick={() => navigate('/welcome')} role="button" tabIndex={0} onKeyDown={e => e.key === 'Enter' && navigate('/welcome')} data-id="element-72">
          <Box color={TEAL} flexShrink={0} data-id="element-73">
            <Home size={26} strokeWidth={1.8} data-id="element-74" />
          </Box>
          <Text color={TEAL} fontWeight="500" fontSize="md" data-id="element-75">
            Home
          </Text>
        </Flex>
      </Box>

      {/* Board dropdown */}
      <Box flexShrink={0} px={5} pb={3} data-id="element-76">
        <Select placeholder="Select Board" value="WPGA_WA" size="sm" borderColor={TEAL} focusBorderColor={TEAL} color={TEAL} sx={{
        '> option': {
          color: '#333'
        }
      }} onChange={() => {}} data-id="element-77">
          <option value="WPGA_WA" data-id="element-78">WPGA - WA</option>
        </Select>
      </Box>

      {/* Committee member list */}
      <Box flex={1} overflowY="auto" px={3} pt={2} pb={2} sx={{
      '&::-webkit-scrollbar': {
        width: '8px'
      },
      '&::-webkit-scrollbar-track': {
        background: '#A5D6A7',
        borderRadius: '4px'
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#00897B',
        borderRadius: '4px'
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#00695C'
      },
      scrollbarColor: '#00897B #A5D6A7',
      scrollbarWidth: 'thin'
    }} data-id="element-79">
        {members.length === 0 ? <Text color={TEAL} fontSize="sm" px={2} opacity={0.7} data-id="element-80">
            No committee selected.
          </Text> : <VStack align="stretch" spacing={1} data-id="element-81">
            {members.map((member, idx) => {
          const isSelected = idx === selectedIndex;
          const isVacant = member.name === '(Vacant)';
          return <Box key={idx} bg={isSelected ? CELL_ACTIVE_BG : CELL_BG} borderRadius="sm" px={3} py={1.5} borderLeft="3px solid" borderLeftColor={isSelected ? '#004D40' : TEAL} cursor="pointer" onClick={() => setSelectedIndex(idx)} _hover={{
            bg: isSelected ? CELL_ACTIVE_BG : '#E0F2E9'
          }} transition="background 0.15s" data-id="element-82">
                  <Text fontSize="10px" fontWeight="600" color={isSelected ? '#004D40' : TEAL} textTransform="uppercase" letterSpacing="0.06em" lineHeight="1.3" data-id="element-83">
                    {member.position}
                  </Text>
                  <Text fontSize="sm" fontWeight={isVacant ? 'normal' : 'semibold'} color={isVacant ? 'gray.400' : isSelected ? '#004D40' : 'black'} fontStyle={isVacant ? 'italic' : 'normal'} lineHeight="1.3" data-id="element-84">
                    {member.name}
                  </Text>
                </Box>;
        })}
          </VStack>}
      </Box>
    </Box>;
}